import React from 'react';
import { Card } from 'antd';
import { Area, Pie, Column } from '@ant-design/charts';

export const IncomeExpenseAreaChart = ({ data }) => (
  <Card title="Income vs Expenses (Monthly)" bordered={false} style={{ marginBottom: 24 }}>
    <Area
      height={220}
      data={data}
      xField="month"
      yField="value"
      seriesField="type"
      color={["#52c41a", "#f5222d"]}
      smooth
      areaStyle={{ fillOpacity: 0.3 }}
      xAxis={{ title: { text: 'Month' } }}
      yAxis={{ title: { text: 'Amount ($)' } }}
      legend={{ position: 'top' }}
    />
  </Card>
);

export const ProfitPieChart = ({ data }) => (
  <Card title="Profit Distribution" bordered={false} style={{ marginBottom: 24 }}>
    <Pie
      height={220}
      data={data}
      angleField="value"
      colorField="type"
      radius={0.9}
      label={{ type: 'outer', content: '{type} {percentage}' }}
      legend={{ position: 'bottom' }}
    />
  </Card>
);

export const InvoiceColumnChart = ({ data }) => (
  <Card title="Invoices Paid Status" bordered={false} style={{ marginBottom: 24 }}>
    <Column
      height={220}
      data={data}
      xField="status"
      yField="count"
      color={["#1890ff", "#faad14"]}
      columnWidthRatio={0.5}
      label={{ position: 'top', style: { fill: '#fff' } }}
      xAxis={{ title: { text: 'Status' } }}
      yAxis={{ title: { text: 'Count' } }}
    />
  </Card>
);
